import React from 'react';
import { CalendarDaysIcon, LifeBuoyIcon, MailIcon, MessagesSquareIcon, RibbonIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
import { bonuses, bonusesSection } from '../data/content';
const icons = {
  rescue: LifeBuoyIcon,
  confidence: MessagesSquareIcon,
  show: RibbonIcon,
  communication: MailIcon,
  camp: CalendarDaysIcon
};
export function Bonuses() {
  return <section id="bonuses" aria-labelledby="bonuses-heading" className="w-full scroll-mt-16 bg-forest-dark px-5 py-14 md:px-8 md:py-24" data-id="element-17" data-mp="1t3ofzorpyxo">
      <div className="mx-auto w-full max-w-content" data-id="element-18" data-mp="3o2eldqgho70j">
        <Reveal data-id="element-19" data-mp="3o3y4dotj4w60">
          <SectionHeading id="bonuses-heading" tone="dark" eyebrow={bonusesSection.eyebrow} title={bonusesSection.title} intro={bonusesSection.intro} data-id="element-20" data-mp="3t0g60ftkcee4" />
        </Reveal>

        <ul className="mt-12 flex flex-wrap justify-center gap-6 md:mt-14" data-id="element-21" data-mp="1r80ehv1b2q7y">
          {bonuses.map((bonus, index) => {
          const Icon = icons[bonus.icon as keyof typeof icons];
          return <Reveal as="li" key={bonus.number} delay={index % 3 * 0.05} className="w-full md:w-[calc(50%-12px)] lg:w-[calc((100%-48px)/3)]" data-id="element-22" data-mp="3detv2wmm8ut3" data-mpi={index}>
                  <article className="flex h-full flex-col overflow-hidden rounded-xl bg-ivory text-charcoal" data-id="element-23" data-mp="3n7is4mhf664w">
                    <div className="aspect-square w-full border-b border-charcoal/10 bg-sage" data-id="element-24" data-mp="2ugha8dmcdwho">
                      {bonus.image ? <img src={bonus.image} alt={`${bonus.title} cover mockup`} width={1024} height={1024} loading="lazy" decoding="async" className="h-full w-full object-cover" data-id="element-25" data-mp="38hbj0xdaxzgv" /> : <div className="flex h-full w-full items-center justify-center p-8" data-id="element-26" data-mp="3ciemd4oadwzm">
                          <div className="flex aspect-[3/4] h-full max-h-[85%] flex-col items-center justify-center rounded-md border border-brass/60 bg-forest px-6 text-center shadow-[0_24px_40px_-24px_rgba(16,44,37,0.6)]" data-id="element-27" data-mp="3hgoh5e63mvkp">
                            <span className="text-[12px] font-semibold uppercase tracking-[0.16em] text-sage" data-id="element-28" data-mp="3qglc1xj30qo7">
                              Bonus {bonus.number}
                            </span>
                            <span aria-hidden="true" className="my-4 h-px w-10 bg-brass" data-id="element-29" data-mp="2xrxm3one1d4b" />
                            <span className="font-serif text-[1.35rem] font-semibold leading-tight text-ivory" data-id="element-30" data-mp="32rsc7pzc9yob">
                              {bonus.title}
                            </span>
                            <Icon className="mt-5 h-7 w-7 text-brass" strokeWidth={1.5} aria-hidden="true" data-id="element-31" data-mp="2a3whgqtbygu6" />
                          </div>
                        </div>}
                    </div>
                    <div className="flex flex-1 flex-col p-7" data-id="element-32" data-mp="27hx6h2q6y453">
                    <div className="flex items-center justify-between" data-id="element-33" data-mp="22lyel55nm3zx">
                      <span className="text-[13px] font-semibold uppercase tracking-[0.14em] text-forest" data-id="element-34" data-mp="1xlk65m054s1d">
                        Bonus {bonus.number}
                      </span>
                      <span className="flex h-11 w-11 items-center justify-center rounded-full border border-brass/60" data-id="element-35" data-mp="1ol5f060hwipy">
                        <Icon className="h-5 w-5 text-forest" strokeWidth={1.5} aria-hidden="true" data-id="element-36" data-mp="1jtx6rdawj3ed" />
                      </span>
                    </div>
                    <h3 className="mt-5 font-serif text-[1.6rem] font-semibold leading-[1.15]" data-id="element-37" data-mp="1evlyv84632ys">
                      {bonus.title}
                    </h3>
                    <p className="mt-3 text-base leading-relaxed text-charcoal/75" data-id="element-38" data-mp="15uxhq4jh8mho">
                      {bonus.benefit}
                    </p>
                    <p className="mt-auto pt-6" data-id="element-39" data-mp="10xnv0wnh2oxj">
                      <span className="block border-t border-charcoal/10 pt-4 text-[15px] font-semibold text-charcoal/80" data-id="element-40" data-mp="30xkg1n68fgtx">
                        Assigned value: {bonus.value}
                      </span>
                    </p>
                    </div>
                  </article>
              </Reveal>;
        })}
        </ul>

        <p className="mx-auto mt-12 max-w-2xl text-center text-base leading-relaxed text-ivory/85 md:text-lg" data-id="element-41" data-mp="2w59gwmjbfz2f">
          Combined assigned bonus value:{' '}
          <strong className="font-semibold text-ivory" data-id="element-42" data-mp="2m96ctb4wlqcu">{bonusesSection.closingValue}</strong>. All
          five kits are included.
        </p>
      </div>
    </section>;
}